import type { RendererProps } from "../core/element-registry"
import { useRenderContext } from "../core/render-context"
import { ElementRenderer } from "./element-renderer"
import { cn } from "../lib/utils"

export function LinkRenderer({ element }: RendererProps) {
  const { resolveSymbol } = useRenderContext()
  const text = element.text ? String(resolveSymbol(element.text) ?? "") : undefined
  const href = element.href ? String(resolveSymbol(String(element.href)) ?? "") : "#"
  const target = element.target as string | undefined
  const rel = element.rel as string | undefined ?? (target === "_blank" ? "noopener noreferrer" : undefined)

  const children = element.children?.map((child) => (
    <ElementRenderer key={child.id} element={child} />
  ))

  return (
    <a
      href={href}
      target={target}
      rel={rel}
      className={cn(element.className)}
    >
      {children ?? text}
    </a>
  )
}
